import axios from "@util/axios";
import projectConfig from "@projectConfig";
import { sha512 } from "js-sha512";
import { trackPromise } from "react-promise-tracker";

const { hostCloud, hostB2 } = projectConfig.api;

export const getUsers = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/users/all-active`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const getDepartmentUsers = async (departmentId) => {
   return axios({
      method: "get",
      url: `${hostCloud}/legacy/department/users?departmentId=${departmentId}`,
      headers: {
         Accept: "*/*",
      },
   });
};

export const getUserWithBoards = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/users/user-info/with-boards`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};
export const getUserData = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/users/user-info`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const changeOrganization = async (oldId) => {
   return axios({
      method: "post",
      url: `${hostCloud}/users/change-organization?departmentId=${oldId}`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};
export const getListWithUserCoordinates = async (
   coordinatesFieldName,
   currentLocation,
   distanceToFilter,
   isDistanceHidden,
   itemsPerPage,
   listId,
   profileId,
   page,
) => {
   const body = profileId
      ? {
           coordinatesFieldName: coordinatesFieldName,
           currentLocation: currentLocation,
           distanceToFilter: distanceToFilter,
           isDistanceHidden: isDistanceHidden,
           itemsPerPage: itemsPerPage,
           listId: listId,
           page: page,
           profileId: profileId,
        }
      : {
           coordinatesFieldName: coordinatesFieldName,
           currentLocation: currentLocation,
           distanceToFilter: distanceToFilter,
           isDistanceHidden: isDistanceHidden,
           itemsPerPage: itemsPerPage,
           listId: listId,
           page: page,
        };
   return axios({
      method: "post",
      url: `${hostCloud}/great-circle-distance`,
      headers: {
         Accept: "*/*",
      },
      data: body,
   });
};

export const getUsersAvatars = async (users) => {
   const queryOfUsers = users.join("%2C");
   return axios({
      method: "get",
      url: `${hostCloud}/user-avatar/batch?usersOldIds=` + queryOfUsers,
      headers: {
         Accept: "*/*",
      },
   });
};

export const getUserWorkingHours = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/users/work-scopes`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const setUserWorkingHours = async (workingHours) => {
   return axios({
      method: "post",
      url: `${hostCloud}/users/add-work-scopes`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: workingHours,
   });
};
export const setUserConsents = async (userConsentsList) => {
   return axios({
      method: "post",
      url: `${hostCloud}/users/accept-consents`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: JSON.stringify({ consentIds: userConsentsList }),
   });
};

export const getUserDataByRegistrationCode = async (registrationCode) => {
   const parameters = JSON.stringify({ code: registrationCode });
   const encodedParameters = encodeURIComponent(parameters);

   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const data = {
      endpoint: `/registration/method/getData/parameters/${encodedParameters}`,
      httpMethod: "GET",
      isAuthenticated: false,
      apiController: "/index.php/restApi",
      host: hostB2,
   };
   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const sendVerificationCode = async (registrationCode) => {
   const parameters = JSON.stringify({ code: registrationCode });

   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const data = {
      endpoint: `/registration/method/sendVerificationCode`,
      httpMethod: "POST",
      isAuthenticated: false,
      apiController: "/index.php/restApi",
      parameters: parameters,
      host: hostB2,
   };
   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const checkRegistrationSmsCode = async (registrationCode, smsCode) => {
   const parameters = JSON.stringify({ code: registrationCode, smsCode: smsCode });

   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const data = {
      endpoint: `/registration/method/verifyCode`,
      httpMethod: "POST",
      isAuthenticated: false,
      apiController: "/index.php/restApi",
      host: hostB2,
      parameters: parameters,
   };
   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};
